  import React, { Component } from 'react';
  import { connect } from 'react-redux';
  import { changeOperatorGroupPreferences, countOperatorGroups, getOperatorGroups } from '../../actions/operatorGroups';
  import { getTablePage } from '../../helpers/functions';
  import _ from 'lodash';
  import OperatorGroups from './OperatorGroups';

  const listColumns = [
    {name: 'Operator group', key: 'name'},
  ];

  class OperatorGroupsHOC extends Component {
    componentDidMount() {
      this.props.getOperatorGroups({
        limit: this.props.rowsPerPage,
        order: listColumns[this.props.orderBy].key + ' ' + this.props.order.toUpperCase()
      });
    }

    handlePageChange = (iconType) => {
      let newPage  = getTablePage(iconType, this.props.page,  this.props.total, this.props.rowsPerPage);
      this.props.changeOperatorGroupPreferences({key: 'page', value: newPage});
    };

    handleRowsPerPage = (rowsPerPage) => {
      rowsPerPage = parseInt(rowsPerPage);
      let newTotalPages = _.ceil(this.props.total / rowsPerPage);
      let currentPage = this.props.page;
      if(parseInt(currentPage) > newTotalPages ){
        currentPage = newTotalPages;
      }

      this.props.changeOperatorGroupPreferences({key: 'rowsPerPage', value: rowsPerPage});
      this.props.changeOperatorGroupPreferences({key: 'page', value: currentPage});
    };

    onRequestSort = (payload) => {
      this.props.countOperatorGroups();
      this.props.changeLabelsOrder(payload);
    };

    handleRowSelect = (id) => {
      this.props.history.push('/operatorGroups/' + id)
    };

    getListRows = () => {
      return this.props.operatorGroups
        .valueSeq().toArray().map(operatorGroup => ({
          id: operatorGroup.get('id'),
          data: [
            operatorGroup.get('name'),
            // label.get('picture') ? 'Uploaded' : undefined
          ],
          label: `OPERATOR GROUPS` + operatorGroup.id
        }))
    };

    render() {
      return (<OperatorGroups
        {...this.props}
        listRows={this.getListRows()}
        listColumns={listColumns}
        handlePageChange={this.handlePageChange}
        handleRowsPerPage={this.handleRowsPerPage}
        handleRowSelect={this.handleRowSelect}
        onRequestSort={this.onRequestSort}
      />);
    }
  }

  const mapStateToProps = state => ({
    operatorGroups: state.operatorGroups.get('operatorGroups'),
    fetching: state.operatorGroups.get('fetching'),
    total: state.operatorGroups.get('total') ?
      state.operatorGroups.get('total') : 0,
    page: state.operatorGroups.get('page'),
    rowsPerPage: state.operatorGroups.get('rowsPerPage'),
    order: state.operatorGroups.get('order'),
    orderBy: state.operatorGroups.get('orderBy'),
  });

  const mapDispatchToProps = dispatch => ({
    getOperatorGroups: (payload) => {
      dispatch(getOperatorGroups(payload))
    },
    changeOperatorGroupPreferences: (payload) => {
      dispatch(changeOperatorGroupPreferences(payload))
    },
    countOperatorGroups: (payload) => {
      dispatch(countOperatorGroups(payload))
    },
  });

  export default connect(mapStateToProps, mapDispatchToProps)(OperatorGroupsHOC);



// WEBPACK FOOTER //
// ./src/containers/OperatorGroups/OperatorGroupsHOC.js